<template>
  <div>
    <div
      v-if="open != openDirectionDown">
      <svg
        class="h-7 w-7"
        viewBox="0 0 24 24"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <g
          stroke="none"
          stroke-width="1"
          fill="currentColor"
          fill-rule="evenodd">
          <polygon points="6 7 12 13 18 7 20 9 12 17 4 9"></polygon>
        </g>
      </svg>
    </div>
    <div
      v-else>
      <svg
        class="h-7 w-7"
        viewBox="0 0 24 24"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <g
          stroke="none"
          stroke-width="1"
          fill="currentColor"
          fill-rule="evenodd">
          <polygon points="6 17   12 11   18 17   20 15   12 7   4 15"></polygon>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    openDirectionDown: Boolean,
    open: Boolean
  }
}
</script>
